import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
  statusTotal: {
    id: 'singlePayerPayemt.status.total',
    defaultMessage: 'Total',
  },
  statusPaymentDueBy: {
    id: 'singlePayerPayemt.status.dueBy',
    defaultMessage: 'Payment due by',
  },
  footerDisclaimerBeginning: {
    id: 'singlePayerPayemt.footerDisclaimer.beginning',
    defaultMessage: 'By clicking on “Pay”, you confirm you accept the',
  },
  footerDisclaimerEnd: {
    id: 'singlePayerPayemt.footerDisclaimer.end',
    defaultMessage: 'and the {merchant} Terms of Service.',
  },
  userAgreement: {
    id: 'singlePayerPayemt.userAgreement',
    defaultMessage: 'Key Travel User Agreement',
  },
  multiCurrencyDisclaimer: {
    id: 'singlePayerPayemt.multiCurrencyDisclaimer',
    defaultMessage: 'You will be charged in {currencyCode} using the conversion rate at the time the payment is processed.',
  },
  externalLink: {
    id: 'singlePayerPayemt.externalLink',
    defaultMessage: 'View website for more details',
  },
  enterDetails: {
    id: 'singlePayerPayemt.enterDetails',
    defaultMessage: 'Enter your details to complete this payment.',
  },
  contactInformationTitle: {
    id: 'singlePayerPayemt.contactInformationTitle',
    defaultMessage: 'Contact information',
  },
  paymentMethodTitle: {
    id: 'singlePayerPayemt.paymentMethodTitle',
    defaultMessage: 'Payment method',
  },
  singlePayerPaymentSubmit: {
    id: 'singlePayerPayemt.submit',
    defaultMessage: 'Pay {amount}',
  },
  viewAllPurchaseDescription: {
    id: 'singlePayerPayemt.viewAllPurchaseDescription',
    defaultMessage: 'View All',
  },
  linkSentAlertTitle: {
    id: 'singlePayerPayemt.linkSentAlertTitle',
    defaultMessage: 'Check your inbox.',
  },
  linkSentAlertBody: {
    id: 'singlePayerPayemt.linkSentAlertBody',
    defaultMessage: 'Click the link we sent then refresh this page.'
  },
  invalidPassword: {
    id: 'singlePayerForm.errors.invalidPassword',
    defaultMessage: 'Invalid password.',
  },
});



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/single-payer-payment.i18n.js